import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import ageVerificationCallbackState from './AgeVerificationCallback.state';
import { handleAgeVerificationCallback } from '../../redux/actions/age-verification/ageVerificationActions';

// Components
import LoadingScreen from '../../components/loading-screen';

const AgeVerificationCallback = () => {
  const dispatch: AppDispatch = useDispatch();
  const { isCancelledRoute } = useSelector(ageVerificationCallbackState);

  useEffect(() => {
    dispatch(handleAgeVerificationCallback());
  }, []);

  return (
    <LoadingScreen
      message={isCancelledRoute ? '' : 'please wait while we verify your age, this could take up to 30 seconds'}
      show
    />
  );
};

export default AgeVerificationCallback;
